<template>
  <div :id="$attrs['id']" :class="[$attrs['class'], 'card__inner--line', { 'card__inner--line--clickable': clickable }]" @click="handleClick">
    <div class="card__inner--line__text ellipsis">
      <span :title="striptags(title)" class="ellipsis" v-html="title"/>
    </div>
    <div class="card__inner--line__button">
      <button-more>
        <slot name="button" />
      </button-more>
    </div>
  </div>
</template>

<script>

import GridMixin from '@/mixins/GridMixin';
import striptags from 'striptags';

export default {
  name: 'HmCardInnerLine',

  mixins: [GridMixin],

  props: {
    title: {
      type: String,
      required: false,
    },
    clickable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    handleClick: function (event) {
      this.$emit('click');
    },
    striptags(text) {
      return striptags(text);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import '~styles/import';
  .card__inner {
    &--line {
      display: grid;
      grid-column-end: span 12;
      grid-template-columns: 1fr 4rem;
      grid-column-gap: 1.5rem;
      position: relative;
      padding-left: 1.4rem;
      padding-right: 1.4rem;
      min-height: 6.2rem;

      &--clickable {
        cursor: pointer;
      }

      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 4px;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: $lightgray;
        box-shadow: inset 0 1px 1px 0 $cardinnergray;
      }

      &:last-of-type {
        padding-bottom: 0;
        margin-bottom: 0;
        &:after {
          content: none;
        }
      }
      &__text {
        display: grid;
        align-content: center;
      }
      &__button {
        justify-self: end;
      }

      &__wrapper {

        .card__inner {
          &--line {
            &:after {
              content: ' ';
            }
          }
        }

        &:last-of-type {
          padding-bottom: 0;
          margin-bottom: 0;

          .card__inner {
            &--line {
              &:last-of-type {
                &:after {
                  content: none;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/HmCardInnerLine.vue